import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import sr from './sr/translation.json';
import en from './en/translation.json';
import de from './de/translation.json';

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources:{sr:{translation:sr},en:{translation:en},de:{translation:de}},
  fallbackLng:'en', supportedLngs:['sr','en','de'],
  interpolation:{escapeValue:false},
  detection:{order:['localStorage','navigator'],caches:['localStorage'],lookupLocalStorage:'i18nextLng'}
});
export default i18n;
